
import { defineComponent } from "vue";
import LButtom from "@/components/LButtom/LButtom.vue";
import LInput from "../LInput.vue";
import { register } from "@/api/auth";
import { setlocalStorage } from "@/helpers/setLocalStore";
import { mapMutations } from "vuex";

export default defineComponent({
  name: "LRegisterForm",
  components: { LButtom, LInput },
  data() {
    return {
      type_pass: "password",
      email: "",
      password: "",
      user: "",
      remail: "",
      rpassword: "",
      input_errors: [] as string[],
      form__btn_text: "Registrar",
    };
  },
  methods: {
    ...mapMutations(["updateSateFromStorage"]),

    showPass() {
      this.type_pass == "password"
        ? (this.type_pass = "text")
        : (this.type_pass = "password");
    },

    NextFocus(id: string) {
      const input = document.getElementById(id)?.focus();
      return input;
    },
    sendData() {
      const user = {
        username: this.user,
        email: this.email,
        password: this.password,
      };

      const repeat_user = {
        email: this.remail,
        password: this.rpassword,
      };

      if (this.chechInputs(user, repeat_user)) {
        this.form__btn_text = "Cargando..";
        register(user).then((res) => {
          if (res.token) {
            this.form__btn_text = "Registrar";
            setlocalStorage(res.token, res.user, true);
            this.updateSateFromStorage();
            this.$router.push("/home");
          }
        });
      } else {
        // focus red on inputs whit errors
        this.markBadInputs();
      }
    },
    chechInputs(
      user: { username: string; email: string; password: string },
      ruser: { email: string; password: string }
    ) {
      if (user.password === ruser.password) {
        return true;
      }
      // if (user.email !== ruser.email) {
      //   this.input_errors.push("EMAIL");
      // }
      if (user.password !== ruser.password) {
        this.input_errors.push("PASSWORD");
      }
      return false;
    },

    markBadInputs() {
      for (let input of this.input_errors) {
        if (input == "EMAIL") {
          const email = document.getElementById("remail");

          if (email?.parentElement) {
            email.parentElement.style.border = "1px solid red";

            setTimeout(() => {
              if (email?.parentElement) {
                email.parentElement.style.border = "2px solid #afafaf";
              }
            }, 5000);
          }
        } else if (input == "PASSWORD") {
          const pass = document.getElementById("rpassword");
          if (pass?.parentElement) {
            pass.parentElement.style.border = "1px solid red";
          }
          setTimeout(() => {
            if (pass?.parentElement) {
              pass.parentElement.style.border = "2px solid #afafaf";
            }
          }, 5000);
        }
      }
    },
  },
});
